import { insertImage } from '@/apollo/images'
import uploadFiles from '@/uploadFiles'

export const uploadImage = {
	methods: {
		async uploadImage(elem, area, image) {
			const name = (await uploadFiles([image], area))[0]
			const data = {
				url: `/${area}/${name}`,
				file_name: name,
				mime: image.type,
				area: area
			}
			if (this.id && this.image) {
				const apolloResult = await this.$apollo.mutate(insertImage(data))
				data.id = apolloResult.data.image.id
			} else if (this.id) {
				data.id = elem.image.id
			}
			return data
		}
	}
}

export const single = {
	data() {
		return {
			type: this.$t('add'),
			buton_text: this.$t('send'),
			error: false,
			loading: false,
			roles: '',
			actualRoles: '',
			DualList: '',
			DualListOptions: null,
			server_error: null,
			rol_group_selected: ''
		}
	},
	props: {
		id: String
	},
	methods: {
		setError(error_list) {
			this.loading = false
			this.$store.dispatch('isLoading', false)
			this.buton_text = this.$t('send')
			this.error = true
			this.server_error = error_list
		},
		startLoadingState() {
			this.server_error = ''
			this.buton_text = this.$t('sending')
			this.loading = true
			this.$store.dispatch('isLoading', true)
		},
		stopLoadingState() {
			this.loading = false
			this.$store.dispatch('isLoading', false)
			this.buton_text = this.$t('sended')
			this.error = false
			this.base = ''
		},
		loadDualList(elems, selection) {
			elems = [...elems]
			selection.forEach(item => {
				elems.forEach((el, index) => {
					if (item.id == el.id) {
						elems.splice(index, 1)
					}
				})
			})
			this.DualListOptions = {
				items: elems,
				selectedItems: [...selection]
			}
		}
	}
}
